<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      子画面定義：処理中画面(STDSDC01C03)                                                                           _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isProcessShow" style="z-index: 1001">
    <div class="popup" style="width: 280px">
      <div class="popup-body">
        <div class="popup-status">
          <img
            src="@/assets/images/TDSCM/Process.gif"
            alt=""
            width="100"
            height="100"
            class="popup-status-image"
          />
          <p class="popup-status-text">処理中です</p>
        </div>
      </div>
      <ProcessingCompleteModal></ProcessingCompleteModal>
    </div>
  </BaseModal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ProcessingCompleteModal from "./STDSDC01C04ProcessingCompleteModal.vue";
import BaseModal from "@/components/Base/BaseModal.vue";

export default {
  name: "ProcessingModal",
  components: {
    ProcessingCompleteModal,
    BaseModal,
  },
  mounted() {
    this.closeModal();
  },
  computed: {
    ...mapGetters("businessModule", ["isProcessShow"]),
  },
  methods: {
    ...mapActions("businessModule", ["showCompleteDialogue"]),
    // **********************************************
    // クローズモーダル
    // **********************************************
    closeModal() {
      this.showCompleteDialogue(false);
    },
  },
};
</script>
<style></style>
